import $ from '@nuskin/nuskinjquery';
import {Agelocme, CartService, ShippingAddress, ShopContextService, OrderManager, SalesOrder,
    PickupUtil, Product, ProductService, ExternalPaymentService, ProcessorCode} from "../shop.js";
import {RunConfigService, events, util, PersonalOfferStorageService, BrowserDetection, ShoppingContext, UrlService} from "@nuskin/ns-util";
import {getCachedConfigField} from '@nuskin/configuration-sdk';
import {UserService} from "@nuskin/ns-account";
import PaymentAdapter from '../payment/PaymentAdapter';

let splitLineItems = [];

const addToCustomList = (customList, type, key, value) => {
    if (value) {
        let found = false;

        customList.forEach((custom) => {
            if ((!type || custom.type === type) && custom.Key === key) {
                custom.Value = value;
                found = true;
            }
        });

        if (!found) {
            let newCustom = {
                Key: key,
                Value: value
            };
            if (type) {
                newCustom.Type = type;
            }
            customList.push(newCustom);
        }
    }
};

const isSpeedOrder = (order) => {
    let processorCode;
    if (order.availablePayments && order.selectedPayment) {
        let payment = order.availablePayments.find(payment => payment.id == order.selectedPayment.paymentTypeId);
        processorCode = payment ? payment.processorCode : null;
    }
    return processorCode && processorCode === ProcessorCode.SPEED_ORDER;
};

const populateItem = (order, salesOrder, shipImmediate, includeSapItems) => {
    let tempItems;

    salesOrder['Item'] = [];
    if (shipImmediate) {
        tempItems = CartService.getItemData(includeSapItems ? {all: true} : {cartItems: true});
    } else if (order.adr) {
        // Make sure we don't have a business portfolio for ADR - shipFuture.
        tempItems = CartService.getItemData(includeSapItems ? {all: true} : {cartAdrItems: true}).filter(item => !item.isBusinessPortfolio);
    } else {
        tempItems = CartService.getItemData({cartOrderItems: true});
    }

    splitLineItems = []; // Clear list of split line items

    tempItems.forEach(item => {
        // If some of this item's quantity (but not all) is being redeemed with points, split this item in the order
        let splitItemByPoints = item.redeem && item.qtyRedeemWithPoints > 0 && item.qtyRedeemWithPoints < item.qty,
            sendItem = {
                SKU: item.isAgelocme ? item.agelocme.code : item.sku,
                RequestedQuantity: splitItemByPoints ? item.qty - item.qtyRedeemWithPoints : item.qty,
                PayWithPoints: splitItemByPoints ? false : item.redeem,
                OneTime: item.isBusinessPortfolio || !item.isAdr,
                Action: item.sapLineId ? "UPDATE" : "ADD",
                Event: item.eventName || undefined // undefined here means Event will not be on the payload where as null it will
            };

        sendItem.Custom = [];

        if (item.globalProductID) {
            sendItem.Custom.push({
                Type: "GPID",
                Key: "GPID",
                Value: item.globalProductID
            });
        }

        if (item.sapLineId) {
            sendItem.LineID = item.sapLineId;
        }
        if (item.isAgelocme) {
            sendItem.Custom.push({
                Type: "CUST_MAT",
                Key: "ID",
                Value: item.agelocme.code
            });
            sendItem.Custom.push({
                Type: "CUST_MAT",
                Key: "NAME",
                Value: item.agelocme.name
            });
            sendItem.Custom.push({
                Type: "CUST_MAT",
                Key: "LABEL",
                Value: item.agelocme.label
            });
        }
        if (item.isExclusive) {
            sendItem.Custom.push({
                Type: "QUALIFICATION",
                Key: "IS_EXCLUSIVE",
                Value: true
            });
        }

        if (item.locallyProduced) {
            sendItem.Custom.push({
                Key: "LOCALLYPRODUCED",
                Value: order.countryCode
            });
        }

        if (item.subPriceFlag) {
            sendItem.Custom.push({
                Type: "SUB_PRICE",
                Key: "SUB_PRICE",
                Value: "X"
            });
        }

        salesOrder["Item"].push(sendItem);

        if (splitItemByPoints) {
            let sendItemCopy = Object.assign({}, sendItem);
            sendItemCopy.RequestedQuantity = item.qtyRedeemWithPoints;
            sendItemCopy.PayWithPoints = true;
            salesOrder["Item"].push(sendItemCopy);

            splitLineItems.push(item.sku);
        }
    });
};

const populateAttribution = (salesOrder) => {
    const sponsorId = util.getSponsorId();

    if (sponsorId) {
        if (sponsorId.match(/^[A-Z]{2}(:?\d{7}|\d{8})$/)) {
            salesOrder.Shipping.ShippingParty.push({
                Type: "RTL_SELLER",
                ShippingMemberID: sponsorId,
                ShippingAddress: {
                }
            });
        } else {
            console.error('Invalid sponsorId', sponsorId);
        }
    }
}

const populateShipping = (order, salesOrder) => {
    let user = UserService.getUser();
    let code;
    let method = order.selectedShippingMethod;
    if (method) {
        code = method.Code;
    }

    //code = (util.countryCode === 'ZA') ? (order.selectedAddress.addressType == "home" ? "ZH" : "ST") : code;

    salesOrder['Shipping'] = {
        ShippingMethod:{
            Code:code,
            ...(getCachedConfigField('showSignatureRequired') && !order.signatureRequired && {NoSignatureRequired: "X"})
        },
        ShippingParty:[]
    };

    let shippingName = user.lastName ? `${user.firstName} ${user.lastName}` : user.firstName;

    let shippingParty = {
        Type: "SHIP_TO",
        ShippingMemberID: user.id,
        ShippingAddress: {
            Name: shippingName,
            Address: {
                Street1: "75 W Center St",
                City: "Provo",
                Region: "UT",
                PostalCode: "84601",
                CountryCode: "US"
            },
            Contact: []
        },
        Custom: [{
            Type: "ADDRESS",
            Key: "TYPE",
            Value: "home"
        }]
    }

    shippingParty.ShippingAddress = {
        Name: order.selectedAddress.shippingAddressName,
        Address: {
            Street1: order.selectedAddress.shippingAddress1,
            Street2: order.selectedAddress.shippingAddress2,
            City: order.selectedAddress.shippingCity,
            District: order.selectedAddress.shippingCounty,
            Region: (!getCachedConfigField('doNotSendRegion') &&
                (!Array.isArray(order.selectedAddress.shippingState) ||
                    order.selectedAddress.shippingState.length > 0))
                ? order.selectedAddress.shippingState
                : null,
            PostalCode: order.selectedAddress.shippingPostalCode,
            CountryCode: order.selectedAddress.shippingCountry
        },
        Contact: [],
        Instructions: order.selectedAddress.shippingInstructions
    };
    shippingParty.Custom = [{
        Type: "ADDRESS",
        Key: "TYPE",
        Value: order.selectedAddress.addressType
    }];
    addContactInfo(shippingParty.ShippingAddress.Contact, order.selectedAddress);

    salesOrder.Shipping.ShippingParty.push(shippingParty);

    if (order.selectedPickupPoint) {
        let shipTo = {
            Type: "PICK_UP",
            ShippingMemberID: user.id,
            ShippingAddress:{
                Name: order.selectedPickupPoint.name,
                Address:{
                    Street1: order.selectedPickupPoint.street,
                    City: order.selectedPickupPoint.city,
                    PostalCode: order.selectedPickupPoint.postalCode
                }
            },
            Custom:[
                {
                    Type:"PICKUPID",
                    Key: "TYPE",
                    Value: order.selectedPickupPoint.id
                },
                {
                    Type:"PICKUPSR",
                    Key: "TYPE",
                    Value: order.selectedPickupPoint.locker
                },
                {
                    Type: "CARRIER_CODE",
                    Key: "Type",
                    Value: order.selectedPickupPoint.carrierCode
                }
            ]
        };
        salesOrder.Shipping.ShippingParty.push(shipTo);
    }

    // This is only used for speed order when using the new processing method. The information in this sections comes from the credit card.
    if (isSpeedOrder(order)) {
        let billTo = {
            Type: "BILL_TO",
            ShippingMemberID: user.id,
            ShippingAddress: {
                Name: order.selectedPayment.billingName,
                Address: {
                    Street1: order.selectedPayment.billingAddress,
                    Street2: "",
                    City: order.selectedPayment.billingCity,
                    District: order.selectedPayment.billingCountry,
                    Region: !getCachedConfigField('doNotSendRegion') ? order.selectedPayment.billingState : null,
                    PostalCode: order.selectedPayment.billingPostalCode,
                    CountryCode: order.selectedPayment.billingCountry
                },
                Contact: [
                    {
                        "Country": order.selectedPayment.billingCountry,
                        "Value": {
                            "value": order.selectedPayment.billingPhone,
                            "Type": "HOMEPHONE"
                        }
                    },

                    {
                        "Country": order.selectedPayment.billingCountry,
                        "Value": {
                            "value": order.selectedPayment.billingEmail,
                            "Type": "EMAIL"
                        }
                    }
                ],
                Instructions: null
            },
            Custom: [
                {
                    Type: "ADDRESS",
                    Key: "TYPE",
                    Value: null
                }
            ]
        };

        salesOrder.Shipping.ShippingParty.push(billTo);
    }

    if (method && method.PickUpLocation) {
        salesOrder.Shipping.ShippingMethod.PickUpLocation = method.PickUpLocation;
    }
    if (order.selectedDeliveryTimeSlot) {
        salesOrder.timeSlotId = order.selectedDeliveryTimeSlot.id;
    }

    // Add pickup person and number
    if (order.pickupInfo) {
        shippingParty = {
            Type:"PICKUP_BY",
            ShippingMemberID: user.id,
            ShippingAddress: {
                Name: order.pickupInfo.pickupName,
                Contact: []
            }
        };
        order.selectedAddress.shippingMobilePhone = order.pickupInfo.pickupNumber;
        addContactInfo(shippingParty.ShippingAddress.Contact, order.selectedAddress);
        salesOrder.Shipping.ShippingParty.push(shippingParty);
    }

    populateAttribution(salesOrder);
};

const addContactInfo = (contacts, selectedAddress) => {
    //Only push contacts if they aren't empty
    if (selectedAddress.shippingPhone) {
        contacts.push({
            Country: selectedAddress.shippingPhoneCountry || selectedAddress.shippingCountry,
            Value: {
                value: selectedAddress.shippingPhone,
                Type: "HOMEPHONE"
            }
        });
    }
    if (selectedAddress.shippingMobilePhone) {
        contacts.push({
            Country: selectedAddress.shippingMobilePhoneCountry || selectedAddress.shippingCountry,
            Value: {
                value: selectedAddress.shippingMobilePhone,
                Type: "MOBILEPHONE"
            }
        })
    }
    if (selectedAddress.shippingEmail) {
        contacts.push({
            Country: selectedAddress.shippingCountry,
            Value: {
                value: selectedAddress.shippingEmail,
                Type: "EMAIL"
            }
        });
    }
};

const populateFeePayment = (order, salesOrder) => {
    try {
        if (order.selectedPayment) {
            salesOrder.Payment = [];
            let paymentToSend = {
                type: 'CCARD',
                Currency: order.currencyCode,
                action: "ADD",
                Custom: [
                    {
                        Key: "PAYMENT_TYPE",
                        Value: order.selectedPayment.paymentTypeId.toString()
                    }
                ]
            };

            if (!order.selectedPayment.unsavedPayment && order.selectedPayment.paymentNumber !== null) {
                paymentToSend.Custom.push({
                    Key:"PROFILE_ID",
                    Value:order.selectedPayment.bePaymentTypeId
                });
            }

            // Add amount to the paymentToSend if authorized externally.
            if (order.selectedPayment.paymentSecurityNumber) {
                paymentToSend.amount = order.orderTotals.grandTotal;
            }
            paymentToSend.CreditCard = {
                "TransactionType": {
                    "value": "INSTALLMENT",
                    "PaymentPeriod": order.selectedPayment.getInstallmentSelectedNumber()
                },
                "CardNumber": order.selectedPayment.paymentNumber,
                "AuthorizationCode": order.selectedPayment.paymentSecurityNumber ? order.selectedPayment.paymentSecurityNumber : "",
                "Name": order.selectedPayment.paymentName ? order.selectedPayment.paymentName : order.selectedPayment.billingName,
                "ExpirationMonth": order.selectedPayment.expMonth,
                "ExpirationYear": order.selectedPayment.expYear,
                "VerificationCode": order.paymentSecurityNumber,
                "PostalCode": order.selectedPayment.paymentPostalCode,
                "EncryptedCardNumber": "",
                "TrackOne": "",
                "Installments": order.selectedPayment.getInstallmentSelectedNumber()
            };
            salesOrder.Payment.push(paymentToSend);
        }
    } catch(err) {
        console.error(err);
    }
};


const populateAdrOverride = (order, salesOrder) => {
    // Handle Adr override number
    if (order.adrOverrideNumber && order.adrOverrideNumber !== 'null'){
        salesOrder.ADROverrideID = order.adrOverrideNumber;
        salesOrder.Reason = order.adrOverrideReason;
    }
};

const populatePitch = (salesOrder) => {
    // Handle promocodes for pitch
    let personalOffer = PersonalOfferStorageService.getPersonalOffer();

    if (personalOffer && personalOffer.discount) {
        let discountCode = personalOffer.discount.code;

        switch (discountCode) {
            // Check for free shipping
            case "POFREESHIP":
                salesOrder.ShippingDiscountCode = discountCode;
                break;
            case "RETAILPRICE":
                //Don't send code for retail
                break;
            // Send code as ProductDiscountCode for anything else
            default: {
                const user = UserService.getUser();
                if (user && user.accountType !== '10' && user.accountType !== '30') {
                    salesOrder.ProductDiscountCode = discountCode;
                }
                break;
            }
        }
    }

    // Set the channel for "Personal Offer".
    if (personalOffer.isGroupOffer)
        salesOrder.Category = "GROUP OFFER";
    else
        salesOrder.Category = "PERSONAL OFFER";
};

function removeItems(cartItems, sapSkus) {
    cartItems.forEach(item => {
        if (!sapSkus.includes(item.sku)) {
            CartService.removeItemByKey(item.key);
        }
    });
}

const populateCategory = (salesOrder) => {
    if (ShoppingContext.isContext(ShoppingContext.MOBILE_AFFILIATE)) {
        salesOrder.Category = "MOBILE AFFILIATE";
    } else if (ShoppingContext.isContext(ShoppingContext.MOBILE_CONSUMER)) {
        salesOrder.Category = "MOBILE CONSUMER";
    } else if (PersonalOfferStorageService.isPersonalOffer()) {
        populatePitch(salesOrder);
    } else if (ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT)) {
        salesOrder.Category = "SKINCONSULT";
    } else if (util.getSponsorId()) {
        // affiliates don't use a subdomain.  So if we have a sponsor and it isn't a pitch then we consider it a storefront
        salesOrder.Category = "STOREFRONT";
    } else {
        salesOrder.Category = 'WEB';
    }
}

/**
 * Handle sku redetermination
 * Redetermined items should become 'real' items, not Sap Added items like all new items
 * in the sap response. Also, such items show which sku they replace in the ReplacedSKU
 * property. This sku needs to be removed from the sapSkus array, and will get removed
 * in the for loop below.
 */
function handleRedetermination(product, sapItem, sapSkus, adr, isAdrItem) {
    if (sapItem.ReplacedSKU && sapItem.ReplacedSKU.length > 0) {
        // and now remove the replaced sku
        sapSkus.splice(sapSkus.indexOf(sapItem.ReplacedSKU), 1);

        // Add the replaced sku back into the cart as a non sap Item so it shows up on the cart page
        CartService.addProductToCart({
            product: product,
            qty: sapItem.LineItem.RequestedQuantity,
            adr: (adr && !adr.shipImmediate && isAdrItem)
        }).finally(() => {});
    }
}

async function addSapItem(newItem, sapItem, sapSkus, adr, isAdrItem, replace) {
    let product;

    product = new Product(newItem);

    const siteUrl = UrlService.getSiteUrl();
    const isEdge = BrowserDetection.isEdge();
    const isFirefox = BrowserDetection.isFirefox();

    // set the base url for images, etc
    product.setBaseUrl(siteUrl);

    // fix image paths for non-edge/firefox
    if (!isEdge && !isFirefox) {
        product.fullImage = product.fullImage
            ? `${product.fullImage.split("?")[0]}?format=pjpg`
            : undefined;
        product.thumbnail = product.thumbnail
            ? `${product.thumbnail.split("?")[0]}?format=pjpg`
            : undefined;
    }

    // Try to update the count, flavor, shade, size, and product points values for the SapItem;
    CartService.getItemData({cartItems: true}).forEach(cartItem => {
        if (cartItem.sku === newItem.sku) {
            product.count = cartItem.count;
            product.flavor = cartItem.flavor;
            product.shade = cartItem.shade;
            product.size = cartItem.size;
            product.points = cartItem.points;
        }
    });

    handleRedetermination(product, sapItem, sapSkus, adr, isAdrItem); // removes items from sapSkus

    // Only honor the OneTime flag from SAP if we are a ADR order
    return await CartService.addProductToCart({
        product: product,
        qty: sapItem.LineItem.RequestedQuantity,
        adr: (adr && isAdrItem),
        sapLineId: sapItem.LineItem.LineID,
        redeem: newItem.redeem,
        qtyRedeemWithPoints: newItem.qtyRedeemWithPoints,
        loyaltyPointsUsed: newItem.loyaltyPointsUsed,
        isBusinessPortfolio: newItem.businessPortfolio,
        replace: replace
    })
}

const syncProductItems = async (order, sapProducts, adr, includeSapItems) => {
    let sapSkus = [],
        cartItems,
        runConfig = RunConfigService.getRunConfig();

    order.clearOutOfStock();
    order.productDiscountAmount = 0;
    order.shippingDiscountAmount = 0;

    if (adr) {
        if (adr.shipImmediate) {
            cartItems = CartService.getItemData(includeSapItems ? {all: true} : {cartItems: true});
        } else {
            cartItems = CartService.getItemData(includeSapItems ? {all: true} : {cartAdrItems: true});
        }
    } else {
        cartItems = CartService.getItemData(includeSapItems ? {all: true} : {cartOrderItems: true});
    }

    if (!includeSapItems) {
        // now we want to simply
        CartService.removeItems({sapItems: true}); // remove all sap line item rows from the cart before we add new sap line items
    }

    // If line items were split (e.g. to accommodate partial payment with points), recombine split line items
    if (splitLineItems.length > 0) {
        sapProducts = toMergedSapProductsList(sapProducts, splitLineItems);
        splitLineItems = [];
    }

    // first loop thru sapProducts to add new ones into the localProducts
    for (const sapItem of sapProducts) {
        order.productDiscountAmount += sapItem.ProductPromoSavings;
        order.shippingDiscountAmount += sapItem.FreightPromoSavings;
        // We need to make sure it is not a BOM item
        // Note that for 3Dsecure, there will be no ParentID because web-service never calls SAP
        if ((typeof sapItem.LineItem.ParentID === "undefined") || sapItem.LineItem.ParentID == 0) {
            if (sapItem.AvailableQuantity < sapItem.LineItem.RequestedQuantity) {
                order.addOutOfStock(sapItem.LineItem.SKU);
                order.addOutOfStockTitle(CartService.getItemTitleBySku(sapItem.LineItem.SKU));
            } else {
                let existingItem = CartService.getFirstItemBySku(sapItem.LineItem.SKU, includeSapItems ? {all: true} : {cartItems: true}),
                    aSku = existingItem ? existingItem.sku : sapItem.LineItem.SKU,
                    newItem = {},
                    isAdrItem = !sapItem.LineItem.OneTime,
                    newItemSku = aSku;

                sapSkus.push(aSku);
                newItem.sku = aSku;
                newItem.title = sapItem.Name;
                // eslint-disable-next-line
                newItem.thumbnail = `${RunConfigService.getBaseUrl()}/content/products/${aSku.substring(0, 2)}/${aSku.substring(2, 4)}/${aSku.substring(4, 6)}/${aSku}/jcr:content/fullImage.img.100.100.png`;       // this is relative and will not work in the assessment app.
                newItem.price = sapItem.Price;
                newItem.loyaltyPointsUsed = sapItem.PointsUsed;
                newItem.priceType = ShopContextService.getPriceType(isAdrItem);
                newItem.pv = sapItem.PSV;
                newItem.backOrderDate = sapItem.BackorderAvailableDate;

                if (sapItem.LineItem.Custom) {
                    let code = null, name = null, label = null;

                    sapItem.LineItem.Custom.forEach(custom => {
                        if (custom.Key === 'ID') {
                            code = custom.Value;
                        } else if (custom.Key === "NAME") {
                            name = custom.Value;
                        } else if (custom.Key === "LABEL") {
                            label = custom.Value;
                        } else if (custom.Key === 'SUB_PRICE') {
                            newItem.subPriceFlag = true;
                        }
                    });
                    if (code != null || name !== null || label != null) {
                        newItem.agelocme = new Agelocme({
                            code: code,
                            isCoreSolution: code.length === 3,
                            name: name,
                            label: label
                        });
                    }
                }

                let matchedItem = cartItems.find((item) => {
                    return (item.isAgelocme && item.agelocme.code === sapItem.LineItem.SKU) ||
                        item.sku === sapItem.LineItem.SKU;
                });
                if (matchedItem) {
                    newItem.sku = matchedItem.sku
                    newItem.isBusinessPortfolio = matchedItem.isBusinessPortfolio;
                    newItem.redeem = matchedItem.redeem;
                    newItem.qtyRedeemWithPoints = matchedItem.qtyRedeemWithPoints;
                    newItem.eventName = matchedItem.eventName;
                }
                if (existingItem) {
                    newItem.thumbnail = existingItem.thumbnail;
                    newItem.title = existingItem.title;
                    newItem.marketAttributes = existingItem.marketAttributes;
                    const sapItemKey = await addSapItem(newItem, sapItem, sapSkus, adr, isAdrItem, !!includeSapItems);
                    CartService.syncCartItemToSapItem(sapItemKey, existingItem.key);
                } else {
                    //order.getItem returns objects of type nuskin.newShop.cartItem
                    try {
                        const data = await ProductService.getProductData(newItemSku, runConfig.country, runConfig.language);
                        if (data.title) {
                            if (runConfig.assessmentApp && newItem.thumbnail.search(/^http/g) === -1) {
                                newItem.thumbnail =  UrlService.getSiteUrl() + '/' + newItem.thumbnail;
                            }
                            newItem.title = data.title; // overwrite with the localized title
                        }
                    } catch (err) {
                        console.error(`Failed to get the product name for ${newItemSku} \n${err}`);
                    }
                    await addSapItem(newItem, sapItem, sapSkus, adr, isAdrItem, !!includeSapItems);
                }
            }
        }
    }

    removeItems(cartItems, sapSkus);
    // this needs to be called here because of the async call to get product info for the
    //  added items to be displayed in the order details section.
    events.publish(events.shop.SIMULATE_COMPLETE);
};

const syncOrderTotals = (sapOrderTotals, orderTotals) => {
    orderTotals['itemSubtotal'] = sapOrderTotals['ItemSubtotal'];
    orderTotals['shipping'] = sapOrderTotals['Shipping'];
    orderTotals['tax'] = sapOrderTotals['Tax'];
    orderTotals['grandTotal'] = sapOrderTotals['GrandTotal'];
    orderTotals['psvTotal'] = sapOrderTotals['PSV'];
    orderTotals['taxBase'] = sapOrderTotals['TaxBase'];
    orderTotals['savings'] = sapOrderTotals['Savings'];
    orderTotals['cv'] = sapOrderTotals['CV'];
    orderTotals['rounding'] = sapOrderTotals['Rounding'];
    orderTotals['taxInclusive'] = sapOrderTotals['TaxInclusive'];
    orderTotals['pointsUsed'] = Math.abs(sapOrderTotals['PointsUsed']);

    // Get the installment fee if it exists.
    let orderTotalsCustom = sapOrderTotals['Custom'];
    if (orderTotalsCustom) {
        orderTotalsCustom.forEach(custom => {
            if (custom['Type'] === 'INSTALLMENT') {
                if (custom['Key'] === 'FEE') {
                    orderTotals['installmentFee'] = custom['Value'];
                } else if (custom['Key'] === 'TEM') {
                    orderTotals['installmentTem'] = custom['Value'];
                } else if (custom['Key'] === 'TEA') {
                    orderTotals['installmentTea'] = custom['Value'];
                } else if (custom['Key'] === 'CFT') {
                    orderTotals['installmentCft'] = custom['Value'];
                }
            } else if (custom['Key'] === 'SUPP_TAX_ONE'){
                orderTotals['suppTaxOne'] = parseFloat(custom['Value']);
            }
        });
    }
};

/**
 * //Todo Strip out this hack.  Order simulate returns the wrong price for ship methods right now...
 */
let shippingHack = function (order, shipping, currency) {
    if (order.selectedShippingMethod) {
        order.selectedShippingMethod.Cost = shipping;
    }
    order.currencyCode = currency;
    return order;
};

const syncShipping = (sapShipping, order) => {
    if (sapShipping && sapShipping.ShippingParty) {
        sapShipping.ShippingParty.forEach(sapShippingParty => {
            if (sapShippingParty.Type === "SHIP_TO") {
                let shipTo = sapShippingParty.ShippingAddress,
                    custom = sapShippingParty.Custom,
                    addressData = {
                        beShippingAddressId: 0,
                        shippingAddressName: shipTo.Name,
                        shippingInstructions: shipTo.Instructions
                    };

                // sync the Address structure
                if (shipTo.Address) {
                    addressData.shippingAddress1 = shipTo.Address.Street1;
                    addressData.shippingAddress2 = shipTo.Address.Street2;
                    addressData.shippingCity = shipTo.Address.City;
                    addressData.shippingCounty = shipTo.Address.District;
                    addressData.shippingState = shipTo.Address.Region;
                    addressData.shippingPostalCode = shipTo.Address.PostalCode;
                    addressData.shippingCountry = shipTo.Address.CountryCode;
                }
                // sync the Contacts
                if (shipTo.Contact) {
                    shipTo.Contact.forEach(shipToContact => {
                        let contactValue = shipToContact.Value;

                        if (contactValue) {
                            switch (contactValue.Type) {
                                case "HOMEPHONE":
                                    addressData.shippingPhone = contactValue.value;
                                    break;
                                case "MOBILEPHONE":
                                    addressData.shippingMobilePhone = contactValue.value;
                                    break;
                                /*
                                 case "EMAIL":
                                 addressData.shippingEmail = contactValue.value;
                                 break;
                                 */
                            }
                        }
                    });
                }
                // always set the addressType to null except if we have Value coming back
                addressData.addressType = null;
                if (custom && custom[0] && (custom[0].Type === "ADDRESS") && (custom[0].Key === "TYPE")) {
                    addressData.addressType = custom[0].Value;
                }

                order.selectedAddress = new ShippingAddress(addressData);
            }
        });
    }
};

/**
 * This method will attempt to put the standard method first, walk in methods second (alphabetic sort), and
 * pickup locations last (alphabetic sort).
 *
 * VN is the only one that will probably be affected by this method sense they added over 50 pickup locations.
 *
 * Standard Shipping: Code = ST.
 * Walk ins: PickUpLocation VN01 or VN04
 * Anything else is just a pickup location
 *
 * @param shippingMethods
 */
function sortShippingAvailableMethods(shippingMethods){
    let MAX_METHODS_WITHOUT_SORTING = 10;

    if (shippingMethods.length > MAX_METHODS_WITHOUT_SORTING) {
        let sortedShippingMethods = [],
            standardShippping,
            walInLocationNames = [],
            walkInLocations = new $.Hashtable(),
            pickupLocationNames = [],
            pickupLocations = new $.Hashtable();

        // Stuff the buckets
        shippingMethods.forEach(shippingMethod => {
            if (shippingMethod.Code === 'ST') {
                standardShippping = shippingMethod;
            }
            else if (shippingMethod.PickUpLocation === 'VN01' || shippingMethod.PickUpLocation === 'VN04') {
                walInLocationNames.push(shippingMethod.Description);
                walkInLocations.add(shippingMethod.Description, shippingMethod);
            }
            else {
                pickupLocationNames.push(shippingMethod.Description);
                pickupLocations.add(shippingMethod.Description, shippingMethod);
            }
        });

        // Assemble the sorted shipping methods
        if (standardShippping) {
            sortedShippingMethods.push(standardShippping);
        }
        if (walInLocationNames.length > 0) {
            walInLocationNames.sort();

            for (let j = 0; j < walInLocationNames.length; j++) {
                sortedShippingMethods.push(walkInLocations.get(walInLocationNames[j]));
            }
        }
        if (pickupLocationNames.length > 0) {
            pickupLocationNames.sort();

            for (let k = 0; k < pickupLocationNames.length; k++) {
                sortedShippingMethods.push(pickupLocations.get(pickupLocationNames[k]));
            }
        }
        return sortedShippingMethods;
    }
    else{
        return shippingMethods;
    }
}

let setShippingAvailableMethodsPickupInfo = function(methods) {
    let pickupIndex;

    methods.forEach(method => {
        if (method.PickUpLocation) {
            pickupIndex = method.Description.indexOf('<br>');
            if (pickupIndex >= 0) {
                //Note that pickupInfo is sanitize when the HTML referenced it
                method.pickupInfo = method.Description.substr(pickupIndex + 4);
                method.Description = method.Description.substr(0, pickupIndex);
            }
        }
    });
};

let setSelectedShipMethod = function(order, matchMethod = {}) {
    let shippingMethodExists = false,
        defaultMethod = order.getDefaultShipMethod(matchMethod);

    if (!order.selectedShippingMethod) {
        order.selectedShippingMethod = defaultMethod;
    } else {
        //The problem is SAP can return extra methods from a simulate so we set the available ship methods to methods returned from SAP
        //The selected ship method points to the object in the old array.  We need to loop and reselect it
        shippingMethodExists = order.syncSelectedShippingMethod();
        if (!shippingMethodExists) {
            order.selectedShippingMethod = defaultMethod;
        }
    }
};

/**
 * Parses pickup points from SAP response, in case shipping method is set to pickup points!
 * @param {Object[]} custom The Custom array on the salesorderrequest
 * @param {Object} order
 */
function setPickupPoints(custom, order) {
    const pupLocations = custom || [];
    if (order.selectedShippingMethod && PickupUtil.supports(order.selectedShippingMethod.Code)) {
        order.pickupPoints = PickupUtil.parse(pupLocations);
        if (order.selectedPickupPoint) {
            order.selectedPickupPoint = order.pickupPoints.find(pickupPoint => order.selectedPickupPoint.id === pickupPoint.id);
        }
    } else {
        order.pickupPoints = null;
        order.selectedPickupPoint = null;
    }
}

/**
 * This function takes an SAP product list and returns a copy of the list where, for each pair of line
 * items X and Y whose SKUs match a list of split line item SKUs, X has been merged back into Y
 * @param sapProducts SAP product list
 * @param splitSKUs array of SKUs for split line items
 */
function toMergedSapProductsList(sapProducts, splitSKUs) {
    let sapProductsCopy = sapProducts.slice();

    splitSKUs.forEach(sku => {
        // This code assumes that if SAP adds any further line items, they occur after the split line
        // items this function is meant to recombine.
        let firstIdx = sapProductsCopy.map(product => product.LineItem.SKU).indexOf(sku);
        let secondIdx = sapProductsCopy.map(product => product.LineItem.SKU).indexOf(sku, firstIdx + 1);

        // Abort if fewer than two matching line items found
        if (firstIdx === -1 || secondIdx === -1) return;

        let firstItem = sapProductsCopy[firstIdx];
        let secondItem = sapProductsCopy[secondIdx];

        // Handle merger of points-related properties
        if (firstItem.LineItem.PayWithPoints) {
            secondItem.LineItem.PayWithPoints = true;

            // Add properties indicating the quantities of this item requested and available for
            // purchase with points
            if (!secondItem.LineItem.PtsRequestedQuantity) secondItem.LineItem.PtsRequestedQuantity = 0;
            secondItem.LineItem.PtsRequestedQuantity += firstItem.LineItem.RequestedQuantity;
            if (!secondItem.PtsAvailableQuantity) secondItem.PtsAvailableQuantity = 0;
            secondItem.PtsAvailableQuantity += firstItem.AvailableQuantity;
        } else if (secondItem.LineItem.PayWithPoints) {
            if (!secondItem.LineItem.PtsRequestedQuantity) secondItem.LineItem.PtsRequestedQuantity = secondItem.LineItem.RequestedQuantity;
            if (!secondItem.PtsAvailableQuantity) secondItem.PtsAvailableQuantity = secondItem.AvailableQuantity;
        }

        // Handle merger of Back-Order Available Date, if present
        if (secondItem.BackorderAvailableDate === null) {
            secondItem.BackorderAvailableDate = firstItem.BackorderAvailableDate;
        }

        // Handle merger of Total Available Quantity, if present
        if (secondItem.TotalAvailableQuantity === null) {
            secondItem.TotalAvailableQuantity = firstItem.TotalAvailableQuantity;
        } else if (firstItem.TotalAvailableQuantity !== null) {
            secondItem.TotalAvailableQuantity += firstItem.TotalAvailableQuantity;
        }

        // Handle merger of other properties
        secondItem.LineItem.OneTime           &= firstItem.LineItem.OneTime;
        secondItem.LineItem.RequestedQuantity += firstItem.LineItem.RequestedQuantity;
        secondItem.AvailableQuantity          += firstItem.AvailableQuantity;
        secondItem.Price                      += firstItem.Price;
        secondItem.Points                     += firstItem.Points;
        secondItem.FreightPromoSavings        += firstItem.FreightPromoSavings;
        secondItem.ProductPromoSavings        += firstItem.ProductPromoSavings;
        secondItem.Tax                        += firstItem.Tax;
        secondItem.TaxBase                    += firstItem.TaxBase;
        secondItem.PSV                        += firstItem.PSV;
        secondItem.CV                         += firstItem.CV;
        secondItem.Freight                    += firstItem.Freight;
        secondItem.BackOrdered                |= firstItem.BackOrdered;
        secondItem.InvalidSku                 |= firstItem.InvalidSku;
        secondItem.GrandFatheredPricing       |= firstItem.GrandFatheredPricing;
        secondItem.AddedBySystem              |= firstItem.AddedBySystem;

        // Merged entry should have line item order ID of the earliest (lowest number) entry for this SKU
        secondItem.LineItem.LineID = Math.min(secondItem.LineItem.LineID, firstItem.LineItem.LineID);

        // All properties have been merged into second line item. Remove first line item.
        sapProductsCopy.splice(firstIdx, 1);
    });

    return sapProductsCopy;
}


let syncPayment = function(sapPayment, localSelectedPayment) {
    if (sapPayment && sapPayment.length > 0) {
        localSelectedPayment.sapPaymentId = sapPayment[0].id;  // This is for SPEED order
    }
};

/**
 * Takes an initial salesOrder object with the order action and reason and populates the rest with the current order.
 *
 * @param salesOrder - SalesOrder with OrderAction and Reason
 * @param adr - Adr info from checkout needed to set the custom field for adr_contract_length
 */
const populateSalesOrder = (action, adr) => {
    let order = OrderManager.getOrder(),
        runConfig = RunConfigService.getRunConfig(),
        lastExternalId = OrderManager.getLastOrderId(),
        salesOrder = new SalesOrder({
            OrderAction: action,
            Reason: 'STANDARD',
            ExternalID: order.externalId,
            CountryCode: order.countryCode,
            SoldToMemberID: order.soldToMemberId,
            ProductDiscountCode: order.productDiscountCode,
            ShippingDiscountCode: order.shippingDiscountCode,
            CommissionInPriorMonth: order.backdating,
            Custom: order.custom,
            GiftReceipt: order.giftReceipt,
            orderProcessingState: order.orderProcessingState
        });
    populateItem(order,salesOrder, (adr && adr.shipImmediate));
    populateAdrOverride(order,salesOrder);

    addToCustomList(salesOrder.Custom, "EVENT", "CODE", runConfig.site);
    if (adr && adr.contractType) {
        addToCustomList(salesOrder.Custom, null, "ADR_CONTRACT_LENGTH", adr.contractType);
    }
    addToCustomList(salesOrder.Custom, "", "SENDER", order.distributorName);
    addToCustomList(salesOrder.Custom, "", "ZZUSE_PTS", order.shippingPayWithPoints ? "X" : "NA");
    const microsite = getCachedConfigField('microsite');
    if (microsite) {
        salesOrder.Reason = "CUSTOM";
        addToCustomList(salesOrder.Custom, "EVENT", "CODE", microsite);
        addToCustomList(salesOrder.Custom, "REASON", "REASON", microsite);
        salesOrder.site = microsite;
    }
    if (getCachedConfigField('enabled')) {
        let loyaltyPointsJson = CartService.getOrderLoyaltyRewardsPointsJson();

        if (loyaltyPointsJson) {
            salesOrder['Pricing'] = loyaltyPointsJson;
        } else {
            salesOrder['Pricing'] = [];
        }
    }

    // Set channel
    populateCategory(salesOrder);

    if (action === 'SIMULATE') {
        if (order.simulateWithoutShipping) {
            // If it has a selectedAddress, that means it already did a simulate before...
            // selectedAddress gets initialized as an empty object (all the fields are null)
            if (order.selectedAddress && order.selectedAddress.shippingAddress1) {
                populateShipping(order, salesOrder);
            } else {
                // Not going to populateShipping...
                console.log("Simulating the order without the shippingAddress...");
            }
        } else {
            populateShipping(order, salesOrder);
        }
        try {
            // For Argentina installments we need to calculate the cost of the installments
            // Todo remove the Argentina check and add config to simulateInstallments
            if (RunConfigService.getRunConfig().country == "AR" &&
                order.selectedPayment &&
                order.selectedPayment.getUseInstallments() &&
                order.selectedPayment.getInstallmentSelectedNumber() > 1) {

                populateFeePayment(order, salesOrder);
            }
        } catch (err) {
            console.log(err);
        }
    }
    // Only populate the payment on the create call
    if (action === 'CREATE') {
        if (adr && adr.shipImmediate) {
            // Check if there was an error on a shipimmediate create previously but an ADR was already created.
            // If so then we need to set the ADROverrideID so we don't create another ADR.
            if (order.errorResponseInfo && order.errorResponseInfo.SalesOrderDetail) {
                salesOrder.ADROverrideID = order.errorResponseInfo.SalesOrderDetail.OrderID;
            } else if (order.externalPaymentAdrNumber) {
                salesOrder.ADROverrideID = order.externalPaymentAdrNumber;
            } else if (ExternalPaymentService.needToHandleExternalPayment()) {
                salesOrder.ADROverrideID = ExternalPaymentService.getAdrOverrideId();
            }
        }
        populateShipping(order, salesOrder);
        PaymentAdapter.populatePayment(order, salesOrder);
        // External payment will reject a payment if we have the same externalId as the last attempt.
        // Clear it from the salesOrder and the order objects
        if (lastExternalId && lastExternalId === order.externalId) {
            salesOrder.ExternalID = null;
            order.externalId = null;
            OrderManager.saveOrders();
        }
        OrderManager.setLastOrderId(order.externalId);
    }
    return salesOrder;
};

/**
 * Maps Sales order detail object to the order object
 * @param {Object} salesOrderDetail
 * @param {Object} adr - Adr object created during checkout.  Needed to syncProductItems
 * @param {boolean} createResponse - Indicates that the salesOrderDetail object is from a createResponse
 */
const toOrder = async (salesOrderDetail, adr, createResponse) => {
    let order = OrderManager.getOrder();
    order.currencyCode = salesOrderDetail.Currency;
    order.orderId = salesOrderDetail.OrderID;
    order.date = salesOrderDetail.Date;
    order.paymentStatus = salesOrderDetail.Status;
    order.backdated = salesOrderDetail.CommissionedInPriorMonth;
    order.allowBackdating = salesOrderDetail.CommissionableInPriorMonth;
    order.externalId = salesOrderDetail.ExternalID;
    if (salesOrderDetail.Custom instanceof Array) {
        order.shippingPayWithPoints = salesOrderDetail.Custom.map(item => item.Key).indexOf('ZZUSE_PTS') > -1;
    }

    if (salesOrderDetail.ShippingAvailableMethods && salesOrderDetail.ShippingAvailableMethods.length > 0) {
        order.shippingAvailableMethods = sortShippingAvailableMethods(salesOrderDetail.ShippingAvailableMethods);
        setShippingAvailableMethodsPickupInfo(order.shippingAvailableMethods);
        setSelectedShipMethod(order, salesOrderDetail.Shipping.ShippingMethod);
        // When an order or ADR is created.  The response from the create call is missing the list of pickup locations
        // The list isn't needed in this case since the user has already created the order so we don't need to update the pickup points
        if (!createResponse) {
            setPickupPoints(salesOrderDetail.Custom, order);
        }
    }
    shippingHack(order, salesOrderDetail.OrderTotals.Shipping, salesOrderDetail.Currency);
    // Only Sync the shipping address if they don't have one
    if (order.simulateWithoutShipping) {
        syncShipping(salesOrderDetail.Shipping, order);
    }

    await syncProductItems(order, salesOrderDetail.LineItemDetails, order.adr ? adr : null);
    syncOrderTotals(salesOrderDetail.OrderTotals, order.orderTotals);
    syncPayment(salesOrderDetail.Payment, order.selectedPayment);
    return order;
};

export default {
    populateSalesOrder,
    toOrder
}
